import cn from '@integrations/classnames'
import type { HTMLAttributes } from '@integrations/react'

import styles from './TransactionActionModalSurface.module.scss'

interface SurfaceProps extends HTMLAttributes<HTMLDivElement> {
  variant?: 'default' | 'compact'
}

function TransactionActionModalSurface({ children, className, variant = 'default', ...props }: SurfaceProps) {
  return (
    <div
      className={cn(styles['surface'], 'transaction-action-modal-surface', className, {
        [styles['surface-compact']]: variant === 'compact'
      })}
      {...props}
    >
      {children}
    </div>
  )
}

function TransactionActionModalInfo({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(styles['info'], 'transaction-action-modal-info', className)} {...props}>
      {children}
    </div>
  )
}

function TransactionActionModalAmount({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(styles['amount'], 'transaction-action-modal-amount', className)} {...props}>
      {children}
    </div>
  )
}

function TransactionActionModalPreview({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn(styles['preview'], 'transaction-action-modal-preview', className)} {...props}>
      {children}
    </div>
  )
}

export {
  TransactionActionModalAmount,
  TransactionActionModalInfo,
  TransactionActionModalPreview,
  TransactionActionModalSurface
}
